import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_NETWORK_ERRORS = new HttpContextToken<boolean>(
    () => false,
);

export const SUPPRESS_GLOBAL_SPINNER = new HttpContextToken<boolean>(
    () => false,
);
